import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type UseLavaReturnOptions = {
  onSuccess?: () => void | Promise<void>;
  onFail?: () => void;
};

export const useLavaReturn = ({ onSuccess, onFail }: UseLavaReturnOptions = {}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lava = params.get('lava');

    if (!lava) return;

    params.delete('lava');
    const newSearch = params.toString();
    navigate({ search: newSearch ? `?${newSearch}` : '' }, { replace: true });

    if (lava === 'success') {
      onSuccess?.();
    } else if (lava === 'fail') {
      onFail?.();
    }
  }, []);
};
